import { memo } from 'react';

import SortAscendingIconSVG from '@/assets/sort-ascending-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ISortAscendingIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={SortAscendingIconSVG} {...props} />
);

export const SortAscendingIcon = memo(ISortAscendingIcon) as typeof ISortAscendingIcon;
